module.exports = __webpack_public_path__ + "img/crc-02.3d88ebc1.jpg";